import { Expand, Shrink } from 'lucide-react';
import type { ReactNode } from 'react';

import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger
} from '@/components/ui/tooltip';

import { DashboardBreadcrumbs } from './DashboardBreadcrumbs';
import { BIG_BAR_FONT, BIG_ICON_BUTTON } from './bigBarStyle';
import { TOOLBAR_TOOLTIP } from './toolbarTooltip';

interface DashboardPageBarProps {
    title: string;
    tab: string;
    status: ReactNode;
    fullscreen: boolean;
    onToggleFullscreen: () => void;
}

export function DashboardPageBar({
    title,
    tab,
    status,
    fullscreen,
    onToggleFullscreen
}: DashboardPageBarProps) {
    const label = fullscreen ? 'Exit fullscreen' : 'Fullscreen';
    return (
        <TooltipProvider>
            <div
                style={{ fontFamily: BIG_BAR_FONT }}
                className="flex justify-between items-center gap-4 px-4 md:px-10 border-gray-300 dark:border-border border-b h-[33px]"
            >
                <DashboardBreadcrumbs title={title} tab={tab} />
                <div className="flex items-center gap-2 shrink-0">
                    {status}
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <button
                                type="button"
                                onClick={onToggleFullscreen}
                                aria-label={label}
                                className={BIG_ICON_BUTTON}
                            >
                                {fullscreen ? (
                                    <Shrink className="w-4 h-4" />
                                ) : (
                                    <Expand className="w-4 h-4" />
                                )}
                            </button>
                        </TooltipTrigger>
                        <TooltipContent {...TOOLBAR_TOOLTIP}>
                            {label}
                        </TooltipContent>
                    </Tooltip>
                </div>
            </div>
        </TooltipProvider>
    );
}
